module.exports = __webpack_public_path__ + "img/step31_a_remove_tray_and_box - Copy.12305f03.png";